/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs */

const en_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plant<span style="[%2$s]"> extra real trees </span> to reduce carbon</span>`)
};

const ar_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> ازرع <span style="[%2$s]">أشجارًا حقيقية إضافية </span> لتقليل الكربون </span>`)
};

const de_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Pflanze<span style="[%2$s]"> extra echte Bäume </span> um Kohlenstoff zu reduzieren</span>`)
};

const es_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Planta<span style="[%2$s]"> árboles reales más</span> para reducir las emisiones de carbono</span>`)
};

const fr_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plantez<span style="[%2$s]"> des arbres réels supplémentaires </span> pour réduire le carbone</span>`)
};

const it_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> Pianta <span style="[%2$s]"> alberi veri extra </span> per ridurre il carbonio </span>`)
};

const ja_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">本物の木を追加で植樹</span>して二酸化炭素を削減</span>`)
};

const ko_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">실제 <span style="[%2$s]">나무를 심어</span> 탄소를 줄이세요</span>`)
};

const pt_br_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plantio de <span style="[%2$s]">árvores reais extras</span> para reduzir o carbono</span>`)
};

const ru_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Сажайте<span style="[%2$s]"> дополнительные настоящие растения,</span> чтобы сократить выбросы углекислого газа</span>`)
};

const th_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">ปลูก<span style="[%2$s]">ต้นไม้จริงเพิ่มเติม</span>เพื่อลดคาร์บอน</span>`)
};

const tr_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Karbon ayak izini azaltmak için<span style="[%2$s]">ekstra gerçek ağaçlar</span>dik</span>`)
};

const zh_cn_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">每月为地球<span style="[%2$s]">种树减碳</span></span>`)
};

const zh_tw_subscription_walkthrough_p1_content_extra_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">每月為地球<span style="[%2$s]">種樹減碳</span></span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">Plant<span style=\"[%2$s]\"> extra real trees </span> to reduce carbon</span>" |
*
* @param {Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_extra_real_tree = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_Extra_Real_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_extra_real_tree(inputs)
	return zh_tw_subscription_walkthrough_p1_content_extra_real_tree(inputs)
});